"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_components_1 = require("@dotdev/next-components");
var Layouts = require("layouts");
var React = require("react");
var BundleListPageTemplate = /** @class */ (function (_super) {
    __extends(BundleListPageTemplate, _super);
    function BundleListPageTemplate(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            bundleID: _this.props.data.page.metafields.bundle.bundle_id ? _this.props.data.page.metafields.bundle.bundle_id : null,
            bundle: _this.props.data.section.bundleSection
        };
        return _this;
    }
    BundleListPageTemplate.prototype.render = function () {
        var page = this.props.data.page;
        var bundleID = this.state.bundleID;
        return (React.createElement(Layouts.Theme, __assign({}, this.props),
            React.createElement("div", { className: "bundle-collection" },
                React.createElement("section", { className: "bg-navy text-arctic py-3-2 w-full overflow-auto" },
                    React.createElement("div", { className: "max-w-xl mx-auto mlg:px-11 md:px-3 px-1-6" },
                        React.createElement("div", { className: "md:h-auto px-0-8 md:px-2-4 md:w-4/5 pb-2" },
                            React.createElement("div", { className: "w-full page-content " }, next_components_1.ShopifyNext.Utils.parseHTML(page.content))),
                        bundleID && React.createElement("div", { className: "rbrBundleBuilder", "bundle-id": "" + bundleID }))))));
    };
    return BundleListPageTemplate;
}(React.Component));
exports.BundleListPageTemplate = BundleListPageTemplate;
